
import React from 'react';
import _ from 'lodash';
import '../styles/App.css';
import Prediction from './Prediction';
import { Age, PredictionRange } from './SVGCollection';

class PredictionsPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            conditionList: []
        };
    }

    getPredictionList() {

        const { conditions, predictions, appType } = this.props;

        const conditionPredictions = _.map(conditions, (condition) => {
            const prediction = predictions.conditions ? predictions.conditions[condition.Condition] : undefined;
            const useFC = appType === 'HLY' ? true : false;

            return (
                <Prediction
                    key={condition.Condition}
                    conditionKey={condition.Condition}
                    conditionTitle={condition.title}
                    icon={PredictionRange}
                    prediction={prediction}
                    useFC={useFC}
                />
            );
        });

        if (this.props.appType === 'HLY') {
            const hlyPrediction = (
                <Prediction
                    key="healthy-life-years"
                    conditionKey="healthy-life-years"
                    conditionTitle="Health span"
                    icon={Age}
                    prediction={predictions.healthy_life_years}
                />
            );

            const hsPrediction = (
                <Prediction
                    key="health-status"
                    reverseOrder={true}
                    conditionKey="health-status"
                    conditionTitle="Health status"
                    icon={PredictionRange}
                    prediction={predictions.health_status}
                />
            );
            return [hlyPrediction, hsPrediction, ...conditionPredictions];
        } else {
            return [...conditionPredictions];
        }
    }

    componentDidMount() {
        // Always generate predictions list on mount, even if appType is undefined
        const predictionsList = this.getPredictionList();
        this.setState({ predictionsList });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.conditions !== this.props.conditions ||
            prevProps.predictions !== this.props.predictions ||
            prevProps.appType !== this.props.appType) {
            // Always regenerate predictions list when any relevant prop changes
            const predictionsList = this.getPredictionList();
            this.setState({ predictionsList });
        }
    }

    render() {
        const predictionsCount = this.state.predictionsList ? this.state.predictionsList.length : 0;
        const containerClass = predictionsCount === 1 ? 'predictions-container single' : 'predictions-container';

        return (
            <div className='container w-100 d-flex flex-column' style={{paddingTop: '30px', minHeight: '100%'}}>

                <div className='title' style={{textAlign: 'left'}}>PREDICTIONS</div>

                {this.props.appType === 'HLY' && (
                    <>
                        {/* Explanation and validation */}
                        <div style={{
                            fontSize: '10pt',
                            color: 'rgba(255, 255, 255, 0.7)',
                            marginBottom: '6px',
                            paddingLeft: '10px',
                            fontFamily: 'Open Sans, Menco',
                            fontWeight: '400',
                            lineHeight: '1.6',
                            maxWidth: '700px'
                        }}>
                            Health span shows predicted years lived in good health. Health status is an overall health score combining all disease risks, weighted by disease burden. Disease cards show how much higher or lower the predicted risk is compared to someone of the same age and sex, with the predicted prevalence shown underneath. Research-validated on 650k+ individuals.
                        </div>

                        {/* Publication reference */}
                        <div style={{
                            fontSize: '8pt',
                            color: 'rgba(255, 255, 255, 0.35)',
                            marginBottom: '20px',
                            paddingLeft: '10px',
                            fontFamily: 'Open Sans, Menco',
                            fontStyle: 'italic',
                            maxWidth: '700px'
                        }}>
                            Kokkorakis M, Folkertsma P, Anagnostakis F, et al. "Prospective estimation of individual health span." Manuscript submitted for publication.
                        </div>
                    </>
                )}

                <div className={containerClass}>
                    {this.state.predictionsList}
                </div>
            </div>
        );
    }
}

export default PredictionsPanel;
